/**
 * App全局store(只用于存放全局公共信息)
 */

const coupon = {
    name: 'coupon',
    namespaced: true,
    state: {
        linkData: {},
        currentCoupon: {},
        currentDisplay: 2,
        oilData: {},
    },
    actions: {
        linkage({ commit }, linkData) {
            commit('SET_STATE', {
                linkData,
            });
        },
        bindCurrent({ commit }, currentCoupon) {
            commit('SET_STATE', {
                currentCoupon,
            });
        },
        setDisplay({ commit }, currentDisplay) {
            commit('SET_STATE', {
                currentDisplay,
            });
        },
        setOilData({ commit }, oilData) {
            commit('SET_STATE', {
                oilData,
            });
        },
    },
};

export default coupon;
